module.exports = __webpack_public_path__ + "static/img/title08.bdc6aa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title08.png
// module id = DcDy
// module chunks = 18